export default __webpack_public_path__ + "static/media/logo_black.188cf847a179e782518051ed5b9517f4.svg";